module.exports = __webpack_public_path__ + "img/vue3-web3-1.bbf316d5.jpg";